module.exports = __webpack_public_path__ + "static/media/sleet.2a4a6fab.svg";